import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ShipmentBooking } from 'app/generated/backend/shipment/api/shipment-booking';
import { ShipmentDetailModel } from 'app/generated/backend/shipment/api/shipment-detail-model';

@Injectable()
export class ShipmentBookingHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	put(
		number: string,
		serviceId: number,
		request: ShipmentBooking
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.put<JsonResourceResponse<ShipmentDetailModel>>(`api/v1/shipment/shipments/${number}/services/${serviceId}/bookings`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	delete(
		number: string,
		serviceId: number,
		bookingId: number
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (bookingId!==null && bookingId!==undefined) {
			params = params.set('bookingId', bookingId.toString());
		}
		return this.http.delete<JsonResourceResponse<ShipmentDetailModel>>(`api/v1/shipment/shipments/${number}/services/${serviceId}/bookings`, { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ShipmentBookingHandlerService
	]
})
export class ShipmentBookingHandlerModule { }
